import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Typography, Spin } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useStoreVsVillagePages from '../useStoreVsVillage';
import LineChart from '../../../charts/lineChart';
import AlertMessage from '../../../components/alertMessage';
import UIHelper from '../../../../../helpers/UIHelper';
import Helpers from '../../../../../helpers';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    summary,
    loading,
    handleDownloadExcel,
    title,
    searchParams,
    loadingPdf,
    handleDownloadPdf,
    errors,
    format,
  } = useStoreVsVillagePages();
  const { t } = useTranslation();

  const byCompany = searchParams.get('by_company');
  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');

  return (
    <>
      <PageHeader title={'SALES TREND: STORE vs VILLAGE'}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
              big
              icon={<PlusOutlined />}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        <AlertMessage
          errors={errors}
          shopRequired
          searchParams={searchParams}
        />
        {byCompany && byPeriod && byShoppingCenter && (
          <Spin spinning={loading}>
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
            </Row>
            <Row>
              <Col xs={24} xxl={12}>
                <Table
                  columns={UIHelper.assignTire(columns)}
                  dataSource={data.tableData}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 1500 }}
                  summary={summary}
                  loading={loading}
                />
              </Col>
              <Col xs={24} xxl={12}>
                <LineChart
                  formatTooltip={(v) => Helpers.changeDotToComa(format(v))}
                  data={data.lineChartData}
                  tableData={data.tableData}
                  colors={['#61cdbb', '#f47560', '#f1e15b', '#e8a838']}
                  itemWidth={150}
                />
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default MainPage;
